import React from 'react';
import { motion } from 'framer-motion';
import { FlameIcon, CloudIcon, BatteryIcon, HeartIcon, WindIcon, LeafIcon } from 'lucide-react';
export function BenefitsSection() {
  const benefits = [{
    text: 'Sentirte menos inflamada',
    icon: FlameIcon,
    iconColor: 'text-orange-500',
    bgColor: 'bg-orange-50'
  }, {
    text: 'Mejorar tu digestión',
    icon: CloudIcon,
    iconColor: 'text-sky-500',
    bgColor: 'bg-sky-50'
  }, {
    text: 'Recuperar energía',
    icon: BatteryIcon,
    iconColor: 'text-amber-500',
    bgColor: 'bg-amber-50'
  }, {
    text: 'Crear hábitos más saludables',
    icon: HeartIcon,
    iconColor: 'text-rose-500',
    bgColor: 'bg-rose-50'
  }, {
    text: 'Sentirte más ligera y en control',
    icon: WindIcon,
    iconColor: 'text-teal-500',
    bgColor: 'bg-teal-50'
  }, {
    text: 'Empezar con pasos simples y sostenibles',
    icon: LeafIcon,
    iconColor: 'text-emerald-500',
    bgColor: 'bg-emerald-50'
  }];
  return <section className="py-12 bg-[#E8EDDF]/50 backdrop-blur-[2px]" data-id="element-15">
      <div className="container mx-auto px-6 max-w-5xl" data-id="element-16">
        <motion.div className="text-center mb-8" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-17">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-black mb-3" data-id="element-18">
            Lo que este plan puede ayudarte a lograr
          </h2>
          <div className="w-24 h-1 bg-sage/30 mx-auto rounded-full" data-id="element-19"></div>
        </motion.div>

        <div className="grid grid-cols-2 sm:grid-cols-3 gap-3" data-id="element-20">
          {benefits.map((benefit, index) => {
          const Icon = benefit.icon;
          return <motion.div key={index} className="bg-white rounded-xl p-4 shadow-sm border border-sage/10 relative overflow-hidden group hover:shadow-md transition-shadow duration-300" initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} data-id="element-21">
                {/* Accent line */}
                <div className="absolute top-0 left-0 w-full h-1 bg-sage/20 group-hover:bg-sage transition-colors duration-300" data-id="element-22"></div>

                <div className={`w-9 h-9 rounded-full ${benefit.bgColor} flex items-center justify-center mb-3 ${benefit.iconColor}`} data-id="element-23">
                  <Icon className="w-4.5 h-4.5" strokeWidth={1.5} data-id="element-24" />
                </div>
                <h3 className="text-sm font-medium text-text-dark leading-snug" data-id="element-25">
                  {benefit.text}
                </h3>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}